import { css } from '@/styled-system/css';

export const zestimateContainerStyles = css.raw({
  padding: '400',
  background: 'bg.neutral',
  fontWeight: 600,
  width: { base: '100%', md: '350px' },
  marginTop: { base: '600', md: 0 },
});
